import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AppInitService} from '@services/app-init.service';
import {storageKey} from '@constants/storage.constants';
import {SessionStorageService} from '@services/session-storage.service';

@Component({
  selector: 'app-token-resolver',
  template: `<p>Redirecting...</p>`
})
export class TokenResolverComponent implements OnInit {
  constructor(
    private initService: AppInitService,
    private route: ActivatedRoute,
    private storage: SessionStorageService,
    private router: Router
  ) {
  }

  // http://localhost:4200/?token=a0f05620f44188964fe09a3635c7e61f67341432b11eaceb1679fc60d8076f95c46a8ef9c1b23fae1a1b032315eca06251755f9fc4b3fae54acb1246c15dbbfd8e3c863563d715c4114562b39afd21fc&token_type=user
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      const tokenType = params['token_type'];

      if (token && tokenType) {
        this.storage.set(storageKey.token, token);
        this.storage.set(storageKey.tokenType, tokenType);

        if (tokenType === 'user') {
          this.router.navigate(['/user']);
        } else if (tokenType === 'institute') {
          this.router.navigate(['/institute']);
        } else {
          this.router.navigate(['/not-found']);
        }
      } else {
        this.router.navigate(['/not-found']);
      }
    });
  }
}
